export const HomeMyViewInitialState = {
  selectedView: {},
  allMViews: [],
  allDViews: [],
  ecosystemOptions: [],
  productOptions: [],
  squadOptions: [],
  kpiOptions: [],
  dimensionOptions: [],
  allProductOptions: [],
  timePeriodOptions: [],
  timePeriods: [],
  activeTab: 'myView',
  selectedAccount: [],
  selectedEcosystem: [],
  selectedProduct: [],
  selectedSquad: [],
  selectedTimePeriod: [],

  marketingFilters: {
    Channel: {
      options: [],
      selectedValue: [],
    },
    DiscussionTopic: {
      options: [],
      selectedValue: [],
    },
    PayerStakeholderType: {
      options: [],
      selectedValue: [],
    },

    TemplateName: {
      options: [],
      selectedValue: [],
    },
    SurveyType: {
      options: [],
      selectedValue: [],
    },
    PresentationName: {
      options: [],
      selectedValue: [],
    },
    KeyMessage: {
      options: [],
      selectedValue: [],
    },
  },

  timePeriodName: 'Oct 21-Sep 22',
  focusAccountChecked: true,
  isAccountAvailable: true,
  viewName: 'Gross Sales by Account',
  kpiId: 1,
  kpiName: 'Gross Sales',
  dimensionName: '',
  noDimensionValue: '',
  benchmarkNoDimensionValue: '',
  chartType: 'KPI',
  chartData: [],
  tableData: [],
  cards: [],
  totalTileCount: 0,
  refreshTiles: false,
  impactedCards: [],
  defaultCards: [],
  selectedKpiName: '',
  showWarningGlobal: false,
  selectedKpi: {},
  expression: '',
  showSuccess: false,
  timespan: '',
  advanceButtonValue: false,
  advanceOptions: '',
  advanceDropdownOptions: [],
  systemAlertsData: [],
  notificationsData: [],
  whatsNewData: {},
};
